// extracted by mini-css-extract-plugin
export default {"NavItem":"NavItem_NavItem__oNqC7"};